<template>
	<div class="export-promotions">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Search Promotions</h1>

		<div class="single-text-wrapper">
			<b-field label="BD Code (Optional)">
				<b-input v-model="bdcode" placeholder="BD Code" @keyup.native.enter="getSyncChanges()"></b-input>
			</b-field>
		</div>

		<div class="single-text-wrapper">
			<b-field label="Select Brand (Optional)" v-if="displayBrandSelection">
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>
		</div>

		<!-- <div class="datepickerWrapper">
			<b-field label="Starting Date From (Optional)">
				<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="startDateFrom" icon="calendar-today"></b-datepicker>
			</b-field>

			<b-field label="Starting Date To (Optional)">
				<b-datepicker
					:date-formatter="dateFormatter"
					placeholder="Click to select..."
					v-model="startDateTo"
					icon="calendar-today"
					:min-date="minDate"
				></b-datepicker>
			</b-field>
		</div> -->

		<div class="button-container">
			<div class="big-button" @click="submit()">Search Promotions</div>
		</div>

		<div v-if="promotions.length > 0">
			<div class="search-promo-wrapper">
				<div>Promotion Code</div>
				<div>Type</div>
				<div>Starting date</div>
				<div>Ending Date</div>
				<div>Shops</div>
				<div>Last update</div>
			</div>

			<div v-for="(item, key) of promotions" :key="key" class="search-promo-wrapper">
				<div>{{ item.name }}</div>
				<div>{{ item.type }}</div>
				<div>{{ convertDate(item.condition.date.from) }}</div>
				<div>{{ convertDate(item.condition.date.to) }}</div>
				<div>{{ displayShops(item.promotion_group.shops) }}</div>
				<div>{{ convertDate(item.updatedAt, true) }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'productsCheck',
	data: () => ({
		limit: 20,
		isLoading: false,
		prefix: 'PPC',
		startDateFrom: null,
		startDateTo: null,
		minDate: null,
		brands: [],
		promotions: [],
		displayBrandSelection: true,
		selectedBrand: null,
		bdcode: null,
		brandSuggestions: '',
		shops: [],

		progress: 0
	}),

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	mounted: function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}

		this.getShops()

		this.getBrands()
	},

	watch: {
		startDateFrom: function(data) {
			this.minDate = data

			this.startDateTo = data
		}
	},

	methods: {
		displayShops: function(shops) {
			if (shops.length == 0) {
				return 'Disabled'
			} else {
				const shopNames = []
				shops.map(findShop => {
					const matchShop = this.shops.filter(shop => {
						return shop._id == findShop
					})

					shopNames.push(matchShop[0].shop_id)
				})

				return shopNames.join(',')
			}
		},

		convertDate: function(data, long = false) {
			if (long) {
				return this.$moment(data).format('DD/MM/YYYY LTS')
			} else {
				return this.$moment(data).format('DD/MM/YYYY')
			}
		},

		// Get list of shops
		getShops: async function() {
			this.shops = []
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		getBrands: async function() {
			const data = {
				limit: 1000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.brands = apiGetBrands.data.list
			}
		},

		submit: async function() {
			this.promotions = []
			this.progress = 0

			if (this.bdcode == null && this.selectedBrand == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Either BD Code or Brand is required!'
				})

				return
			}

			if (this.startDateFrom !== null && this.startDateTo == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Please select both dates'
				})

				return
			}

			this.isLoading = true

			let dateFrom = null
			let dateTo = null

			if (this.startDateFrom) {
				// For start date
				dateFrom = this.$moment(this.startDateFrom)
					.set({ hour: 0 })
					.format('x')
			}

			if (this.startDateTo) {
				// For end date
				dateTo = this.$moment(this.startDateTo)
					.set({ hour: 24 })
					.format('x')
			}

			var data = {
				limit: this.limit,
				populate: ['promotion_group'],
				sort: {
					createdAt: 'desc'
				}
			}

			if (dateFrom) {
				data.date = {
					from: {
						$gte: dateFrom,
						$lte: dateTo
					}
				}
			}

			// For BD Code
			if (this.bdcode) {
				let product = await this.$api.getProductDetail({ data: { bd_code: this.bdcode } })
				let productID = product.data._id

				if (product) {
					data.target_products = productID
				}
			}

			if (this.selectedBrand) {
				data.brands = this.selectedBrand._id
			}

			const apiGetPromotions = await this.$api.getPromotions({ data })

			if (!apiGetPromotions) {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'No result found'
				})

				this.isLoading = false

				return
			}

			apiGetPromotions.data.list.map(promo => {
				this.promotions.push(promo)
			})

			if (apiGetPromotions.data.total > this.limit) {
				var totalLoop = Math.ceil(apiGetPromotions.data.total / this.limit)

				var i
				var skip

				// Loop all the pagers
				for (i = 1; i < totalLoop; i++) {
					skip = i * this.limit

					data.skip = skip

					const results = await this.$api.getPromotions({ data })

					results.data.list.map(promo => {
						this.promotions.push(promo)
					})
				}
			}

			this.isLoading = false
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
